// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AnalysisIcon = ({
  color = "#0F2C52",
  size = 31,
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1824_4591)">
        <path
          d="M1.4375 15.5C1.4375 19.2296 2.91908 22.8065 5.55631 25.4437C8.19354 28.0809 11.7704 29.5625 15.5 29.5625C19.2296 29.5625 22.8065 28.0809 25.4437 25.4437C28.0809 22.8065 29.5625 19.2296 29.5625 15.5C29.5625 11.7704 28.0809 8.19354 25.4437 5.55631C22.8065 2.91908 19.2296 1.4375 15.5 1.4375C11.7704 1.4375 8.19354 2.91908 5.55631 5.55631C2.91908 8.19354 1.4375 11.7704 1.4375 15.5Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1875 22.0625V14.5625"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0625 22.0625H8.9375V10.8125"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6875 22.0625V15.5"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4375 22.0625V12.6875"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1824_4591">
          <rect
            width="30"
            height="30"
            fill={color}
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
